<template>
  <div class="input-filed-container">
    <!--TODO v-htmlのセキュリティ対策 -->
    <p v-html="$t('yourFamilysMedicalHistory.whetherYourParentsOrSiblingsHave')" class="text"/>
      <disease-question
        v-for="(disease, index) in FAMILY_HISTORY"
        :key="index"
        :diseaseCode="disease"
        useIn="FAMILY_HISTORY"
        @toggleDisease="toggleDisease"
        @isChecked="setCountOfCheckedQuestion"
      />
      <hr>

    <next-button
      :label="$t('common.next')"
      :disabled="isDisable"
      @click="clickNextButton"
      class="next-button"
    />
  </div>
</template>

<script>
import DiseaseQuestion from "../../components/molecules/AiDiseasePrediction/DiseaseQuestion";
import NextButton from '../../components/atoms/NextButton'

export default {
  data() {
    return {
      FAMILY_HISTORY: [
        'FMLY_APOP_PATIEN_YN',
        'FMLY_DIABML_PATIEN_YN',
        'FMLY_CANCER_PATIEN_YN',
        'FMLY_HDISE_PATIEN_YN',
        'FMLY_HPRTS_PATIEN_YN'
      ],
      // 病歴質問項目の初期状態数
      countOfCheckedQuestion: 0
    };
  },
  components: {
    DiseaseQuestion,
    NextButton
  },
  computed: {
    // "つぎへ"ボタン入力可能かどうか判定する
    isDisable: function(){
      // 全ての病歴項目をチェックできているか確認する
      if (this.countOfCheckedQuestion === this.FAMILY_HISTORY.length) {
        return false;
      }
      else {
        return true;
      }
    }
  },
  methods: {
    toggleDisease(diseaseCode, bool) {
      this.$store.dispatch(`aiPrediction/set${diseaseCode}`, bool);
    },
    clickNextButton() {
      this.$emit('increment')
    },
    // チェックされた病歴質問項目を計算する
    setCountOfCheckedQuestion() {
      this.countOfCheckedQuestion += 1;
    }
  },
  created() {
  //スクロールの位置を初期化；　indexをページトップにする処理
  scrollTo(0,0);
  },
};
</script>

<style scoped>
.input-filed-container {
  width: 100%;
  margin: auto;
}
.text {
  text-align: left;
  font-weight: bold;
  line-height: 30px;
  margin-bottom: 25px;
}
.next-button {
  margin-top: 40px;
}
</style>
